import { render, staticRenderFns } from "./OnlineStoreProductForm.vue?vue&type=template&id=79d2abc9"
import script from "./OnlineStoreProductForm.vue?vue&type=script&lang=js"
export * from "./OnlineStoreProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports